function Overlays({ overlays }) {
  return (overlays || []).map((Overlay) => Overlay);
}

export default Overlays;
